import React, { useRef } from "react";
import "./styles/CakeNCandle.css";

const CakeNCandle = ({ isBlownOut = false, onDoubleTap }) => {
  const lastTapRef = useRef(0);

  const handleClick = () => {
    if (isBlownOut || !onDoubleTap) return;
    const now = Date.now();
    const DOUBLE_TAP_DELAY = 400;
    if (now - lastTapRef.current < DOUBLE_TAP_DELAY) {
      onDoubleTap();
      lastTapRef.current = 0;
    } else {
      lastTapRef.current = now;
    }
  };

  const handleDoubleClick = () => {
    if (isBlownOut || !onDoubleTap) return;
    onDoubleTap();
  };

  return (
    <div
      className={`cake ${!isBlownOut ? "interactive" : ""}`}
      onClick={handleClick}
      onDoubleClick={handleDoubleClick}
      title={!isBlownOut ? "Double tap or double click the cake to blow out the candle!" : undefined}
    >
      <div className="plate" />
      <div className="layer layer-bottom" />
      <div className="layer layer-middle" />
      <div className="layer layer-top" />
      <div className="icing" />

      <div className="drip drip1" />
      <div className="drip drip2" />
      <div className="drip drip3" />
      <div className="drip drip4" />

      <div className={`candle ${isBlownOut ? "out" : ""}`}>
        <div className="flame" />
      </div>

      {isBlownOut && (
        <div className="smoke-wrapper">
          <span className="smoke-puff puff-1" />
          <span className="smoke-puff puff-2" />
          <span className="smoke-puff puff-3" />
          <span className="smoke-puff puff-4" />
        </div>
      )}
    </div>
  );
};

export default CakeNCandle;
